import { Component, OnInit } from '@angular/core';
import { InvestFundService } from '../invest-fund.service';
import { FundsIncome, InvestFund } from '../funds-income';
import { Router } from '@angular/router';


@Component({
  selector: 'app-invest-fund-mais-retorno',
  templateUrl: './invest-fund-mais-retorno.component.html',
  styleUrls: ['./invest-fund-mais-retorno.component.css'],

})
export class InvestFundMaisRetornoComponent extends FundsIncome implements OnInit {
 
  constructor(private service: InvestFundService, router: Router) {
    super(service, router);
  }

  ngOnInit() {
    this.currentMonth = new Date().getMonth() + 1;

    this.getAllDataFromService(this.selectedYear);
  }

  //Auxiliar methods
  public getAllDataFromService(year: string){
    this.funds.forEach(fund => {
      this.service.getInvests(fund.name).subscribe(data => {
        this.retrieveDataFromJson(year, data, fund); //fund.returns, fund.label, fund.lastUpdate);
      });
    });
  }

  public retrieveDataFromJson(year: string, jsonData: any, fundInv: InvestFund){  //arrayToUpdate: string[], fundName: string, fundLastUpdate: Date){
    //retreive return per month list
    for (let index = 0; index < 12; index++) {
      fundInv.returns[index] = `${jsonData.years[year][index + 1]}`.slice(0, 4);
      if (fundInv.returns[index] == "unde")
        fundInv.returns[index] = ""
    }

    //retreive lastQuoteDate
    var epochDateLastQuote = jsonData["stats"]["last_quote_date"];
    fundInv.lastUpdate = epochDateLastQuote ? new Date(epochDateLastQuote) : null;
    fundInv.yearTotalReturn = `${jsonData.years[year]["year"]}`.slice(0, 4);

    if(year === new Date().getFullYear().toString()){
      super.updateAllFundsMonthTable(fundInv.returns, fundInv.label, this.currentMonth, fundInv.lastUpdate);
    } else{
      super.updateAllFundsMonthTable(fundInv.returns, fundInv.label, 12, fundInv.lastUpdate);
    }
  }

  onSelectedYearChange(event: any) {
    this.selectedYear = event.target.value;
    this.allFundsLastMonths = [];
    this.getAllDataFromService(this.selectedYear);

    this.fundCalcReturn = this.calculateReturns(this.selectedFund, this.selectedMonth, this.fundInvestedValue).toString();
  }

  public addNewFund() {
    var newFund = new InvestFund(this.newFundName, this.newFundLabel, 0);
    if(this.allAvailableFundsCtrl.value){
      newFund = this.allAvailableFundsCtrl.value;
    }

    this.service.getInvests(newFund.name).subscribe(data => {
      this.retrieveDataFromJson(this.selectedYear, data, newFund); // .returns, newFund.label, newFund.lastUpdate);
    });

    this.funds.push(newFund);
    this.allAvailableFundsCtrl.setValue("");
  }
}
